import { getApp } from "@/service/appList";
import { openApp } from "@/libs/common";
export default {
  name: "enterApp",
  data() {
    return {};
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await getApp(this.$route.query.code);
      if (res.data && res.data.result === 0) {
        openApp(this, res.data.retVal);
      }
    }
  }
};